// GFF Patronaty - slider logotypów (Swiper z window, ładowany w stopce)
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var sliders = document.querySelectorAll('.gff-patronat__slider');
    if (!sliders.length || typeof window.Swiper === 'undefined') return;

    sliders.forEach(function (slider) {
      var group = slider.closest('.gff-patronat__group');

      new window.Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 40,
        watchOverflow: true,
        rewind: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: {
          prevEl: group ? group.querySelector('.gff-patronat__arrow--prev') : null,
          nextEl: group ? group.querySelector('.gff-patronat__arrow--next') : null,
        },
        breakpoints: {
          1232: {
            spaceBetween: 112,
          },
        },
      });
    });
  });
})();
